import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { ChevronLeft, ChevronRight } from '@mui/icons-material'
import { Box, Fab } from '@mui/material'
import engineLogo from 'assets/brand/jetpac/engine-logo.png'
import jetpacLogo from 'assets/brand/jetpac/jetpac-logo.png'
import OrbitSession from 'hooks/useCookies'
import PropTypes from 'prop-types'

import NavLinks from './NavbarLinks'
import ProfileMenu from './NavbarProfileMenu'

function SideNavBar({ collapsedSideBar, toggleCollapsedSideBar }) {
  const role = OrbitSession.get('role')
  return (
    <div id='sideNavBar'>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.35)',
          zIndex: '1',
          backgroundColor: '#000869',
          transition: 'all .3s ease-in-out',
          height: '100vh'
        }}
        width={collapsedSideBar ? '250px' : '100px'}
      >
        <Fab
          size='small'
          sx={{
            margin: 0,
            top: 50,
            left: collapsedSideBar ? 230 : 80,
            right: 'auto',
            bottom: 'auto',
            position: 'fixed',
            transition: 'all .3s ease-in-out'
          }}
          onClick={() => {
            toggleCollapsedSideBar(!collapsedSideBar)
          }}
        >
          {collapsedSideBar ? <ChevronLeft /> : <ChevronRight />}
        </Fab>

        <Box
          component={RouterLink}
          to=''
          sx={{
            width: '250px',
            display: 'flex',
            justifyContent: 'center',
            margin: `16px 0 48px 0`
          }}
          data-cy='orbitLogo'
        >
          {collapsedSideBar ? (
            <img width='75%' src={engineLogo} />
          ) : (
            <img width='15%' src={jetpacLogo} />
          )}
        </Box>
        <Box
          sx={{
            display: 'flex',
            height: '100%',
            width: '100%',
            flexDirection: 'column',
            justifyContent: 'space-between',
            overflowY: 'hidden'
          }}
        >
          <NavLinks role={role} toggled={collapsedSideBar} />
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            borderTop: '1px solid #CFD8E3',
            padding: `8px 4px`,
            width: '100%'
          }}
        >
          <ProfileMenu toggled={collapsedSideBar} />
        </Box>
      </Box>
    </div>
  )
}

SideNavBar.propTypes = {
  hideToggle: PropTypes.bool,
  collapsedSideBar: PropTypes.bool,
  toggleCollapsedSideBar: PropTypes.func
}

export default SideNavBar
